import Vue from 'vue'
import Config from '@/config'
import UnleashService from '@/services/unleash'

let resource = null

const actions = {
  triggerReadinessChecker: {
    method: 'POST',
    url: `${Config.publicLanggraphApiUrl}/ahaslides/api/readiness-checker/run`,
  },

  triggerReadinessCheckerV2: {
    method: 'POST',
    url: `${Config.ahaaiv2Url}/api/ai-v2/readiness-checker/run`,
  },

  getReadinessPotentialIssues: {
    method: 'GET',
    url: `${Config.baseUrl}/api/readiness-checker/issues?presentationId={presentationId}`,
  },

  resolveIssues: {
    method: 'POST',
    url: `${Config.publicLanggraphApiUrl}/ahaslides/api/readiness-checker/resolve`,
  },

  resolveIssuesV2: {
    method: 'POST',
    url: `${Config.ahaaiv2Url}/api/ai-v2/readiness-checker/resolve`,
  },

  ignoreIssue: {
    method: 'POST',
    url: `${Config.baseUrl}/api/readiness-checker/issues/{id}/ignore`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const useAhaaiv2 = () => Boolean(Config.ahaaiv2Url) && UnleashService.getVariant('AHA-42863-ahaaiv2-routing').name === 'treatment'

const triggerReadinessChecker = async ({ presentationId }) => {
  if (!resource) initResource()

  const action = useAhaaiv2() ? resource.triggerReadinessCheckerV2 : resource.triggerReadinessChecker
  const res = await action({ presentationId })
  return res.body
}

const getReadinessPotentialIssues = async ({ presentationId }) => {
  if (!resource) initResource()

  const res = await resource.getReadinessPotentialIssues({ presentationId })
  return res.body.issues
}

const resolveIssues = async ({ presentationId, issueId }) => {
  if (!resource) initResource()

  const action = useAhaaiv2() ? resource.resolveIssuesV2 : resource.resolveIssues
  const res = await action({}, { presentationId, issueId })
  return res.body
}

const ignoreIssue = async ({ id, presentationId }) => {
  if (!resource) initResource()

  const res = await resource.ignoreIssue({ id }, { presentationId })
  return res.body
}

export default {
  initResource,
  triggerReadinessChecker,
  getReadinessPotentialIssues,
  resolveIssues,
  ignoreIssue,
}
